import React from "react";
import assign from "lodash/assign";
import get from "lodash/get";
import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import { Navigation } from "react-router";
import { RaisedButton } from "material-ui";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../../stores/OrderStore";
import EventStore from "../../stores/EventStore";
import PassStore from "../../stores/PassStore";
import PersonStore from "../../stores/PersonStore";
import OrderActions from "../../actions/OrderActions";
import EventActions from "../../actions/EventActions";
import PassActions from "../../actions/PassActions";
import CouponActions from "../../actions/CouponActions";

export default statics(
  {
    willTransitionTo({ params, location }, replace, callback) {
      const { query } = location;

      EventActions.fetchOne.defer(query.event, { forceNoAllOverwrite: true });
      if (query.pass) {
        PassActions.fetchOne.defer(query.pass);
      }

      if (
        location.action === "POP" &&
        OrderStore.getState().orderData.subitems
      ) {
        // If navigating back, don't reset order flow
        return callback();
      }

      OrderActions.newOrderFlow();

      let event = EventStore.getEventById(query.event);
      let ticketBuckets = event
        ? event.ticket_buckets.filter(
            b =>
              b.pass_adjusted &&
              b.pass_adjusted[query.pass] &&
              b.pass_adjusted[query.pass].quantity_available > 0
          )
        : [];

      OrderActions.updateCurrentOrder({
        return: query.return,
        event: query.event,
        pass: query.pass,
        subitems: (ticketBuckets.length
          ? ticketBuckets.map(b => ({
              ticket_bucket: b.id,
              quantity: ticketBuckets.length === 1 ? 1 : 0
            }))
          : []
        ).concat(
          TENANT.donate_inline_order_prompt_for_passholder_orders
          || TENANT.donate_inline_order_prompt_for_membershipholder_orders
            ? [{ inline_donation: true }]
            : []
        )
      });
      CouponActions.reset();

      callback();
    },
    willTransitionAway() {
      OrderActions.dropReservedSeats.defer();
      EventActions.clearNoAllOverwrite.defer();
    }
  },

  (
    @connectToStores
    class QuickOrderOverlay extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          hasGoneBack: false
        };

        this.cancel = this.cancel.bind(this);
      }

      static getStores() {
        return [OrderStore, EventStore, PersonStore, PassStore];
      }

      static getPropsFromStores() {
        var state = OrderStore.getState();
        state.getOrderById = OrderStore.getOrderById;
        state.getEventById = EventStore.getEventById;
        state.getPassById = PassStore.getPassById;
        state.person = PersonStore.getState().details;
        state.isLoggedIn = PersonStore.getState().isLoggedIn;
        return state;
      }

      static get contextTypes() {
        return {
          router: React.PropTypes.object.isRequired,
          appSettings: React.PropTypes.object.isRequired
        };
      }

      componentWillMount() {
        if (this.context.appSettings.passholder_one_click) {
          this.submit();
        }
      }

      componentWillReceiveProps(newProps) {
        if (
          this.context.appSettings.passholder_one_click &&
          this.props.orderSuccess &&
          !this.state.hasGoneBack
        ) {
          this.setState({ hasGoneBack: true });
          this.context.router.goBack();
        }

        let event = newProps.getEventById(this.props.orderData.event);
        if (
          this.props.orderData.subitems.length === 0 &&
          event &&
          event.ticket_buckets.length &&
          event.ticket_buckets.some(
            b =>
              b.pass_adjusted &&
              b.pass_adjusted[this.props.orderData.pass] &&
              b.pass_adjusted[this.props.orderData.pass].quantity_available > 0
          )
        ) {
          let ticketBuckets = event.ticket_buckets.filter(
            b =>
              b.pass_adjusted[this.props.orderData.pass].quantity_available > 0
          );
          OrderActions.updateCurrentOrder.defer({
            subitems: ticketBuckets
              .map(b => ({
                ticket_bucket: b.id,
                quantity: ticketBuckets.length === 1 ? 1 : 0
              }))
              .concat(
                TENANT.donate_inline_order_prompt_for_passholder_orders
                || TENANT.donate_inline_order_prompt_for_membershipholder_orders
                  ? [{ inline_donation: true }]
                  : []
              )
          });
        }
      }

      cancel() {
        if (!(this.props.orderInProgress || this.props.orderSuccess)) {
          this.context.router.goBack();
        }
      }

      submit() {
        OrderActions.submitOrder.defer();
      }

      render() {
        let event = this.props.getEventById(this.props.orderData.event);

        return (
          <BaseOverlay
            onRequestClose={this.cancel}
            className={this.props.className}
            zIndex={2000}
          >
            {event && event.external_tickets_url ? (
              <div style={{ padding: 20, textAlign: "center" }}>
                <RaisedButton
                  label={"Continue to checkout"}
                  primary={true}
                  onClick={() => {
                    let win = window.open(event.external_tickets_url, "_blank");
                    win.focus();
                  }}
                />
              </div>
            ) : (
              <Checkout
                orderInProgress={
                  this.context.appSettings.passholder_one_click ||
                  this.props.orderInProgress
                }
                orderSuccess={this.props.orderSuccess}
                orderErrorMessage={this.props.orderErrorMessage}
                orderData={this.props.orderData}
                orderSeatTimeout={this.props.orderSeatTimeout}
                completedOrder={this.props.getOrderById(
                  this.props.completedOrderId
                )}
                updateCurrentOrder={OrderActions.updateCurrentOrder}
                person={this.props.person}
                event={event}
                pass={
                  this.props.orderData.pass
                    ? this.props.getPassById(this.props.orderData.pass) || {
                        id: this.props.orderData.pass
                      }
                    : undefined
                }
                person={this.props.person}
                isLoggedIn={this.props.isLoggedIn}
                isQuickOrder={true}
                cancel={this.cancel}
                submit={this.submit}
              />
            )}
          </BaseOverlay>
        );
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/quick-order.jsx